import React from "react";
import {Divider} from "@material-ui/core";
import ICommonFormProps from "../../yoello-lib/modules/dynamicForms/interfaces/ICommonFormProps";
import FormSwitchWithText from "../../yoello-lib/modules/dynamicForms/FormComponents/FormSwitchWithText";

export const EnableSettingOption = (props: ICommonFormProps) => {
  return (
    <div>
      <FormSwitchWithText {...props} />
      <div style={{margin:"2.5rem 0"}}>
         <Divider/>
      </div>
    </div>
  );
};
